import "./map.js";

// Erst nach den Karten-Callbacks starten: gespeicherte Zustimmung kann Google sofort laden.
if (window.klaroConfig && !window.klaro) {
    const runtimePath = "../klaro.js";
    const script = document.createElement("script");
    script.src = new URL(runtimePath, import.meta.url).href;
    script.dataset.config = "klaroConfig";
    script.onload = () => {
        document.getElementById("klaro-cookie-notice")?.classList.add("is-visible");
    };
    document.head.appendChild(script);
}
